import styled from "styled-components";

export const Container = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;

  position: relative;

  height: 70px;
  padding: 0 5px;
  margin-bottom: 10px;
`;
